import React from 'react';
import { Link } from 'react-router-dom';
import LazyLoad from 'react-lazyload';
import './blogStyles.css';

const BlogCard = ({ blog }) => {
  const calculateReadingTime = (content) => {
    const words = content.split(/\s+/).length;
    const minutes = Math.ceil(words / 200);
    return `${minutes} min read`;
  };

  const stripMarkdownAndHtml = (text) => {
    // Remove HTML tags
    let stripped = text.replace(/<[^>]*>/g, '');
    // Remove Markdown headers
    stripped = stripped.replace(/^#{1,6}\s+/gm, '');
    // Remove Markdown links
    stripped = stripped.replace(/\[([^\]]+)\]\([^\)]+\)/g, '$1');
    // Remove Markdown bold/italic
    stripped = stripped.replace(/(\*\*|__)(.*?)\1/g, '$2');
    stripped = stripped.replace(/(\*|_)(.*?)\1/g, '$2');
    // Remove Markdown code blocks
    stripped = stripped.replace(/```[\s\S]*?```/g, '');
    stripped = stripped.replace(/`([^`]+)`/g, '$1');
    // Remove extra whitespace
    stripped = stripped.replace(/\s+/g, ' ').trim();
    return stripped;
  };

  const getExcerpt = (blog) => {
    if (blog.excerpt) {
      return stripMarkdownAndHtml(blog.excerpt);
    }
    const plainContent = stripMarkdownAndHtml(blog.content);
    return plainContent.substring(0, 120);
  };

  return (
    <div className="blog-card">
      <LazyLoad>
        <Link to={`/blog/${blog.slug}`} className="blog-card-link">
          <div className="blog-card-image-container">
            {blog.thumbnailUrl && (
              <img
                src={blog.thumbnailUrl}
                alt={blog.title}
                className="blog-card-image"
                loading="lazy"
              />
            )}
            <div className="blog-card-overlay">
              <span className="blog-card-category">{blog.category || 'General'}</span>
            </div>
          </div>
          <div className="blog-card-content">
            <h3 className="blog-card-title">{blog.title}</h3>
            <p className="blog-card-excerpt">
              {getExcerpt(blog)}...
            </p>
            <div className="blog-card-meta">
              <span className="blog-card-author">By {blog.author}</span>
              <span className="blog-card-date">
                {new Date(blog.createdAt.seconds * 1000).toLocaleDateString()}
              </span>
              <span className="blog-card-reading-time">
                {calculateReadingTime(blog.content)}
              </span>
            </div>
            <div className="blog-card-cta">
              <span className="read-more-text">Read More</span>
              <svg className="read-more-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 17L17 7M17 7H7M17 7V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
          </div>
        </Link>
      </LazyLoad>
    </div>
  );
};

export default BlogCard;